import { render, staticRenderFns } from "./PieWidget.vue?vue&type=template&id=1ce78d25"
import script from "./PieWidget.vue?vue&type=script&lang=js"
export * from "./PieWidget.vue?vue&type=script&lang=js"
import style0 from "./PieWidget.vue?vue&type=style&index=0&id=1ce78d25&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports